import VuexHelper from '@/utilities/service/vuex/Helper'
import state from './state'
import actions from './actions'
import mutations from './mutations'

const helper = new VuexHelper(require.context('.', true, /index\.js$/))
const modules = helper.modules()

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  modules,
}
